"use client";

import dynamic from "next/dynamic";
import { isAutomatedAuditRuntime } from "@/lib/auditDetection";

const ChatWidgetLazy = dynamic(() => import("./ChatWidgetLazy"), {
  ssr: false,
  loading: () => null,
});

const ToastViewport = dynamic(() => import("./ToastViewport"), {
  ssr: false,
  loading: () => null,
});

export function ClientSideLayoutAddons() {
  if (isAutomatedAuditRuntime()) {
    return null;
  }

  return (
    <>
      <ChatWidgetLazy />
      <ToastViewport />
    </>
  );
}


